export const LogoMark = ({ className = "h-8 w-8" }) => (
  <img
    src="/brand/logo.png"
    alt="Savy Kerno logo"
    data-testid="brand-logo"
    className={`${className} rounded-lg object-contain`}
  />
);

export default function BrandLogo({ className = "h-8 w-8" }) {
  return <LogoMark className={className} />;
}
